export const ARCHIVED_RECORDS_EXPORT_DISABLED_REASON = 'Export is not available for archived records';
